import { combineReducers } from 'redux';

const newPropertyFromScratchReducer =
  function (state = {}, action) {
    switch (action.type) {
    case 'change_address': {
      return { ...state, address: action.address };
    }
    case 'change_city': {
      return { ...state, city: action.city };
    }
    case 'change_country': {
      return { ...state, country: action.country };
    }
    case 'change_state': {
      return { ...state, state: action.state };
    }
    case 'change_zip': {
      return { ...state, zip: action.zip };
    }
    case 'change_county': {
      return { ...state, county: action.county };
    }
    case 'change_sale_or_lease': {
      return { ...state, sale_or_lease: action.sale_or_lease };
    }
    case 'change_name': {
      return { ...state, name: action.name };
    }
    case 'change_location_description': {
      return { ...state, location_description: action.location_description };
    }
    case 'change_property_type_id': {
      return { ...state, property_type_id: action.property_type_id };
    }
    case 'change_building_size': {
      return { ...state, building_size: action.building_size };
    }
    case 'change_building_class': {
      return { ...state, building_class: action.building_class };
    }
    case 'change_sale_price': {
      return { ...state, sale_price: action.sale_price };
    }
    case 'change_lease_rate': {
      return { ...state, lease_rate: action.lease_rate };
    }
    case 'change_lot_size': {
      return { ...state, lot_size: action.lot_size };
    }
    case 'change_number_of_units': {
      return { ...state, number_of_units: action.number_of_units };
    }
    case 'change_zoning': {
      return { ...state, zoning: action.zoning };
    }
    case 'change_year_built': {
      return { ...state, year_built: action.year_built };
    }
    case 'change_year_renovated': {
      return { ...state, year_renovated: action.year_renovated };
    }
    case 'change_occupancy': {
      return { ...state, occupancy: action.occupancy };
    }
    case 'change_aiIngestMetadata': {
      return { ...state, aiIngestMetadata: action.aiIngestMetadata };
    }
    case 'change_aiFeedback': {
      return { ...state, aiFeedback: action.aiFeedback };
    }
    case 'change_showAiFeedbackForm': {
      return { ...state, showAiFeedbackForm: action.showAiFeedbackForm };
    }
    case 'set_aiPopulatedFields': {
      return { ...state, aiPopulatedFields: action.aiPopulatedFields };
    }
    case 'set_currentAiFields': {
      return { ...state, currentAiFields: action.currentAiFields };
    }
    case 'set_inferredFields': {
      return { ...state, inferredFields: action.inferredFields };
    }
    case 'set_aiDocUploadSuccess' : {
      return { ...state, aiDocUploadSuccess: action.aiDocUploadSuccess };
    }
    case 'change_generate_sale_description': {
      return { ...state, generate_sale_description: action.generate_sale_description };
    }
    case 'change_generate_sale_bullets': {
      return { ...state, generate_sale_bullets: action.generate_sale_bullets };
    }
    case 'change_generate_lease_description': {
      return { ...state, generate_lease_description: action.generate_lease_description };
    }
    case 'change_generate_lease_bullets': {
      return { ...state, generate_lease_bullets: action.generate_lease_bullets };
    }
    default: {
      return {
        zip: '', 
        state: '', 
        city: '', 
        address: '',
        generate_sale_description: false,
        generate_sale_bullets: false,
        generate_lease_description: false,
        generate_lease_bullets: false,
        ...state
      };
    }
    }
  };

export default combineReducers({
  brokerSelectOptions: (state = []) => state, // readonly
  propertyTypes: (state = {}) => state, // readonly
  newPropertyFromScratchLocation: newPropertyFromScratchReducer
});
